'use client';

import { useCallback, useEffect, useMemo } from 'react';
import { useRouter } from 'next/navigation';

import useGlobalState from './useGlobalState';
import { myAccountUrl } from 'src/services/route-utils';

export default function useUser({ redirectTo = '', redirectIfFound = false, redirectIfNotFound = false }) {
    const { user, setLoadUser, logout } = useGlobalState();
    const router = useRouter();

    const safeRedirect = useCallback((path: string) => router.push(path), [router]);
    const safeReplace = useCallback((path: string) => router.replace(path), [router]);
    const safeLoadUser = useCallback(() => setLoadUser(), [setLoadUser]);

    useEffect(() => {
        // if no redirect needed, just return (example: already on /dashboard)
        // if user data not yet there (fetch in progress, logged in or not) then don't do anything yet
        if (!redirectTo || !user) return;

        if (
            // if redirectTo is set, redirect if the user was not found.
            (redirectTo && !redirectIfFound && !user?.id) ||
            // if redirectIfFound is also set, redirect if the user was found
            (redirectIfFound && user?.id)
        ) {
            safeRedirect(redirectTo || myAccountUrl('/rezultate'));
        }
    }, [user, redirectIfFound, redirectTo, safeRedirect]);

    useEffect(() => {
        if (!redirectIfNotFound || user) return;

        safeLoadUser().then((user) => {
            if (!user) {
                safeReplace(myAccountUrl('/login'));
            }
        });
    }, [redirectIfNotFound, user, safeReplace, safeLoadUser]);

    return { user, setLoadUser, logout, safeReplace };
}
